enum RunViewPreference {
    COLLAPSED = 'collapsed',
    EXPANDED = 'expanded',
}

export default RunViewPreference;
